export default __webpack_public_path__ + "static/media/b7.39f16ce9.webp";